import { API } from "../urls";

const fetchOpts = { credentials: 'include' };

// Dashboard istatistikleri
export const fetchDashboardStatistics = async (companyId, startDate, endDate) => {
    const res = await fetch(API.get_dashboard_statistics(companyId, startDate, endDate), fetchOpts);
    return res;
};

// Aylık istatistikler
export const fetchMonthlyStatistics = async (companyId, months) => {
    const res = await fetch(API.get_monthly_statistics(companyId, months), fetchOpts);
    return res;
};

// Son ödemeler
export const fetchRecentPayments = async (companyId, limit) => {
    const res = await fetch(API.get_recent_payments(companyId, limit), fetchOpts);
    return res;
};

// Ödeme dağılımı
export const fetchPaymentDistribution = async (companyId, startDate, endDate) => {
    const res = await fetch(API.get_payment_distribution(companyId, startDate, endDate), fetchOpts);
    return res;
};

// En çok ödeme yapanlar
export const fetchTopAccounts = async (companyId, startDate, endDate) => {
    const res = await fetch(API.get_top_accounts(companyId, startDate, endDate), fetchOpts);
    return res;
};

// Zaman serisi
export const fetchTimeSeries = async (companyId, period) => {
    const res = await fetch(API.get_time_series(companyId, period), fetchOpts);
    return res;
};
